<template>
  <div>
    <el-page-header @back="goBack" content=""></el-page-header>
    <div class="topic-outer">
      <div class="appraisal-center fonts">
        <div class="pub-line">
          <span style="display: inline-block;width: 80px;text-align: right">名称：</span>
          <span class="glay">{{ appInfo.appName }}({{ appInfo.appTypeName }})</span>
        </div>
        <div class="pub-line">
          <span style="display: inline-block;width: 80px;text-align: right">应用ID：</span>
          <span class="glay">{{ appInfo.appid }}</span>
        </div>
        <div style="margin-top: 30px">
          <span style="display: inline-block;width: 80px;text-align: right">渠道：</span>
          <span>
            <el-tag
                :class="{ 'tag-marr': true, activeBg: tagIndex == index }"
                v-for="(item, index) in getChannel"
                :key="index"
                @click="activeEvent(index, item.channelAccountId)"
                effect="plain"
            >{{ item.channelTypeName }} ( {{ item.account }} )</el-tag
            >
          </span>
        </div>
        <div style="margin-top: 30px;">
          <span style="display: inline-block;width: 80px;text-align: right">关键字：</span>
          <span>
            <el-tag
                class="tag-marr"
                :key="tag"
                v-for="tag in getAdversing"
                closable
                :disable-transitions="false"
                @close="handleClose(tag)">
  {{ tag }}
</el-tag>
<el-input
    class="input-new-tag"
    v-if="inputVisible"
    v-model="input"
    ref="saveTagInput"
    size="small"
    @keyup.enter.native="onSubmitPush"
    @blur="onSubmitPush"
>
</el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">+ Key Word</el-button>
          </span>
        </div>
        <div style="margin-top: 30px">
          <span style="display: inline-block;width: 80px;text-align: right"></span>
          <el-button type="primary" @click="onSubmit">保存</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {isEmpty} from "../../utils/tools/index";

export default {
  data() {
    return {
      isEmpty,
      appInfo: {},
      getChannel: [],
      getAdversing: [],
      tagIndex: 0,
      loading: false,
      app: {},
      input: '',
      inputVisible: false
    };
  },
  watch: {},
  created() {
    this.appInfo = this.$route.query;
    this.app.appInfoId = parseInt(this.$route.query.appInfoId);
    this.getAreadyChannel(this.$route.query.appInfoId); //需要显示的渠道

  },
  methods: {
    /* 获取该app下已经关联的渠道 */
    async getAreadyChannel(appInfoId) {
      const {data: resData} = await this.$get(
          `/app/channel/list?appInfoId=${appInfoId}`,
          {
            params: {
              status: 1,
              paging: false,
            },
          }
      );
      if (resData.result != 200) return;
      if (!isEmpty(resData.data)) {
        this.getChannel = resData.data;
        this.app.channelAccountId = resData.data[0].channelAccountId;
      }
      this.adversingData();
    },

    handleClose(tag) {
      this.getAdversing.splice(this.getAdversing.indexOf(tag), 1);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick( ()=> {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    /**
     * 获取关键字
     */
    async adversingData() {
      this.loading = true;
      const {data: resData} = await this.$get("/app/keyword/list", {
        params: {
          appInfoId: this.appInfo.appInfoId,
          channelAccountId: this.getChannel[this.tagIndex].channelAccountId,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      if(resData.data){
        this.getAdversing = resData.data;
      }else {
        this.getAdversing = []
      }
    },
    /**
     * 选择渠道ID-激活
     */
    activeEvent(index, channelAccountId) {
      this.tagIndex = index;
      this.app.channelAccountId = channelAccountId;
      this.inputVisible = false
      this.input = ''
      this.getAdversing = []
      this.adversingData()
    },

    onSubmitPush() {
      if(this.input){
        this.getAdversing.push(this.input)
        this.input = ''
        this.inputVisible = false;
      }
    },

    async onSubmit() {
      let params = {
        appInfoId: this.appInfo.appInfoId,
        channelAccountId: this.getChannel[this.tagIndex].channelAccountId,
        keywords: this.getAdversing,
      }
      const {data: res} = await this.$post("/app/keyword/info", params);
      if (res.result != 200) return;
      this.$message.success("添加成功!");
      this.inputVisible = false
      this.adversingData()
    },

    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.appraisal-title {
  color: #3a3a3a;
}

.appraisal-center {
  width: 90%;
  margin: 0 auto;
}

.fonts {
  font-size: 14px;
}

.topic-outer {
  width: 100%;
  background: #fff;
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 30px;
}

.flex-box {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.fl1 {
  flex: 1;
  -webkit-flex: 1;
}

.glay {
  color: #8492a6;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.pub-line {
  margin-top: 30px;
}

.pub-marr {
  margin-top: 20px;
}

.marr {
  margin-top: 30px;
}

.tag-marr {
  margin-right: 5px;
  cursor: pointer;
}

.subject {
  color: #8492a6;
  margin-left: 10px;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.activeBg {
  background: #b3d8ff;
  color: #fff;
}

.active-bg1 {
  background: #fbc4c4;
  color: #fff;
}

.diplay {
  display: inline-block;
}

.screenshot {
  display: inline-block;
  vertical-align: text-top;
}

.video-label {
  margin-right: 15px;
}

.item-add {
  margin: 15px 0;

  .el-button {
    margin-bottom: 15px;
  }

  .el-button img {
    max-height: 12px;
  }
}

.style-outer {
  background: #fff;
  float: left;
  margin: 0 20px 20px 0;
  width: 108px;
  height: 110px;
  border: 1px solid #ddd;
  cursor: pointer;
  position: relative;

  .style__font {
    line-height: 5px;
    margin: 0 0 0 10px;
  }

  .isCheck {
    position: absolute;
    top: 0;
    right: 5px;
    z-index: 2;

    .el-icon-success {
      font-size: 20px;
      color: #ddd;
    }
  }
}
.button-new-tag {
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
  background-color: #ecf5ff;
  color: #409EFF;
}
.input-new-tag {
  width: 90px;
  vertical-align: bottom;
}
</style>